var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list.length > 0)?_c('div',{staticClass:"message-question-tip"},[_c('div',[_vm._v("您还可以试着问：")]),_c('div',{staticClass:"message-question-tip-list"},_vm._l((_vm.list),function(item){return _c('span',{key:item,on:{"click":function($event){return _vm.$emit('newQuestion', item)}}},[_vm._v(_vm._s(item))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }